import axios from 'axios';
import { API_URL_LOCAL, API_URL_PRODUCTION } from '../config';

const isLocalHost = window.location.hostname === 'localhost';
const baseApiUrl = isLocalHost ? API_URL_LOCAL : API_URL_PRODUCTION;

export interface VisibilitySettings {
  travel: boolean;
  home: boolean;
}

export async function getVisibilitySettings(): Promise<VisibilitySettings> {
  try {
    const response = await axios.get(`${baseApiUrl}/visibility`);
    return response.data;
  } catch (error) {
    console.error('Error fetching visibility settings:', error);
    // Return default settings if API fails
    return {
      travel: true,
      home: true,
    };
  }
}
